import locales from '@jira/platform__supported-locales/src/supported-locales.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export {
	/**
	 * @deprecated Use `@jira/platform__application-editions` instead
	 */
	defaultLocale,
	/**
	 * @deprecated Use `@jira/platform__application-editions` instead
	 */
	french,
	/**
	 * @deprecated Use `@jira/platform__application-editions` instead
	 */
	type Locale,
	/**
	 * @deprecated Use `@jira/platform__application-editions` instead
	 */
	standardizeLocale,
} from '@jira/platform__supported-locales/src/supported-locales.tsx';

/**
 * @deprecated Use `@jira/platform__application-editions` instead
 */
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default locales;
